(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-deals-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.campaign-anchor').forEach((navigation) => {
    if (navigation.dataset.ready === 'true') return

    navigation.dataset.ready = 'true'
    const links = [...navigation.querySelectorAll('a[href*="#"]')]
    const items = links
      .map((link) => {
        const hash = new URL(link.href, window.location.href).hash
        return { link, target: hash ? document.querySelector(hash) : null }
      })
      .filter((item) => item.target)

    const activate = (activeItem) => {
      items.forEach((item) => {
        const isActive = item === activeItem
        item.link.classList.toggle('is-active', isActive)
        if (isActive) item.link.setAttribute('aria-current', 'page')
        else item.link.removeAttribute('aria-current')
      })
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const getTargetTop = (item) => {
      const content = item.target.querySelector('.campaign-product__inner, .campaign-compare__header') || item.target
      return content.getBoundingClientRect().top + window.scrollY
    }
    const getScrollOffset = () => {
      const stickyTop = Number.parseFloat(window.getComputedStyle(navigation).top)
      const headerOffset = Number.isFinite(stickyTop) ? stickyTop : 0
      const navigationRect = navigation.getBoundingClientRect()
      return headerOffset + navigationRect.height + 16
    }

    let pendingItem = null
    let settleTimer
    const getDestination = (item) => Math.max(0, Math.min(
      getTargetTop(item) - getScrollOffset(),
      document.documentElement.scrollHeight - window.innerHeight
    ))
    const finishScroll = () => {
      if (!pendingItem) return
      const item = pendingItem
      pendingItem = null
      const destination = getDestination(item)
      if (Math.abs(window.scrollY - destination) > 1) {
        window.scrollTo({ top: destination, behavior: 'instant' })
      }
      update()
    }

    const scrollToItem = (item, updateHistory = true) => {
      const hash = new URL(item.link.href, window.location.href).hash

      window.clearTimeout(settleTimer)
      pendingItem = item
      activate(item)
      window.scrollTo({
        top: getDestination(item),
        behavior: reducedMotion.matches ? 'instant' : 'smooth'
      })
      settleTimer = window.setTimeout(finishScroll, 160)

      if (updateHistory && window.location.hash !== hash) {
        window.history.pushState(null, '', hash)
      }
    }

    let ticking = false
    const update = () => {
      ticking = false
      if (pendingItem) {
        activate(pendingItem)
        return
      }
      const marker = window.scrollY + getScrollOffset() + 1
      let activeItem = items[0]
      items.forEach((item) => {
        const targetTop = getTargetTop(item)
        if (targetTop <= marker) activeItem = item
      })
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        activeItem = items[items.length - 1]
      }
      activate(activeItem)
    }

    const triggers = [...links, ...document.querySelectorAll('.campaign-hero__button[href^="#"]')]
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const hash = new URL(trigger.href, window.location.href).hash
        const activeItem = items.find((item) => item.target.matches(hash))
        if (activeItem) {
          event.preventDefault()
          scrollToItem(activeItem)
        }
      })
    })

    window.addEventListener('hashchange', () => {
      const activeItem = items.find((item) => item.target.matches(window.location.hash))
      if (activeItem) scrollToItem(activeItem, false)
    })

    window.addEventListener('scroll', () => {
      if (pendingItem) {
        window.clearTimeout(settleTimer)
        settleTimer = window.setTimeout(finishScroll, 160)
      }
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(update)
    }, { passive: true })

    const cancelScroll = () => {
      pendingItem = null
      window.clearTimeout(settleTimer)
    }
    window.addEventListener('wheel', cancelScroll, { passive: true })
    window.addEventListener('touchstart', cancelScroll, { passive: true })
    window.addEventListener('pointerdown', cancelScroll, { passive: true })
    window.addEventListener('keydown', (event) => {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) cancelScroll()
    })

    update()

    if (window.location.hash) {
      window.requestAnimationFrame(() => {
        const activeItem = items.find((item) => item.target.matches(window.location.hash))
        if (activeItem) scrollToItem(activeItem, false)
      })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strategic-partnership"] && !Shopify.designMode) return;
  try {
    
  function initializeRetailPartnership(root) {
    if (root.dataset.retailInitialized) return;
    root.dataset.retailInitialized = 'true';
    const events = new AbortController();
    root.querySelector('[data-sp-inquiry-link]')?.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const inquiry = root.querySelector('.sp__inquiry');
      if (!inquiry) return;
      event.preventDefault();
      inquiry.focus({ preventScroll: true });
      inquiry.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }, { signal: events.signal });
    const handledSuccess = new WeakSet();
    const handledForms = new WeakSet();
    let submittedForm;
    const dialog = document.createElement('dialog');
    dialog.className = 'sp-success-dialog';
    const title = document.createElement('h2');
    title.id = `${root.closest('[id]').id}-success-title`;
    dialog.setAttribute('aria-labelledby', title.id);
    const message = document.createElement('p');
    const close = document.createElement('button');
    close.className = 'button sp-retail-button';
    close.type = 'button';
    close.textContent = 'Close';
    dialog.append(title, message, close);
    root.append(dialog);
    close.addEventListener('click', () => dialog.close(), { signal: events.signal });
    dialog.addEventListener('close', () => {
      const form = submittedForm;
      if (!form) return;
      const app = form.closest('.globo-form-app');
      form.reset();
      const builder = window.Globo?.FormBuilder;
      if (builder?.handleResetForm && builder.forms?.[form.dataset.id]) builder.handleResetForm(form);
      form.querySelectorAll('.has-error, .has-success, .block-container.errors').forEach(element => {
        element.classList.remove('has-error', 'has-success', 'errors');
      });
      form.querySelectorAll('.help-block.error').forEach(error => error.remove());
      form.querySelectorAll('[aria-invalid]').forEach(element => element.removeAttribute('aria-invalid'));
      form.querySelectorAll('.gfb__label__shink, .gfb__label__filled, .gfb__label__autofill').forEach(element => {
        element.classList.remove('gfb__label__shink', 'gfb__label__filled', 'gfb__label__autofill');
      });
      app?.querySelectorAll('.message').forEach(element => {
        element.style.display = 'none';
        handledSuccess.delete(element);
      });
      const errorSummary = app?.querySelector('.gfb__error-summary');
      if (errorSummary) {
        errorSummary.textContent = '';
        errorSummary.hidden = true;
      }
      form.style.removeProperty('display');
      app?.classList.remove('sp-submission-complete');
      submittedForm = undefined;
      form.querySelector('input[data-type="text"]')?.focus({ preventScroll: true });
    }, { signal: events.signal });

    function showSuccess(success) {
      const app = success.closest('.globo-form-app');
      submittedForm = app?.querySelector('form.g-container');
      app?.classList.add('sp-submission-complete');
      title.textContent = success.querySelector('.gfb__content-title')?.textContent.trim() || 'Thank You for Your Interest!';
      message.textContent = success.querySelector('.content')?.textContent.trim() || 'Your inquiry has been submitted successfully. Our partnership team will review your information and get back to you shortly.';
      handledSuccess.add(success);
      if (!dialog.open) dialog.showModal();
    }

    document.addEventListener('globo.formbuilder.form.submitted', event => {
      const form = event.detail?.form;
      if (!form || !root.contains(form)) return;
      const filledClasses = ['gfb__label__shink', 'gfb__label__filled', 'gfb__label__autofill'];
      const filledLabels = Array.from(form.querySelectorAll(filledClasses.map(name => `.${name}`).join(',')))
        .map(element => ({ element, classes: filledClasses.filter(name => element.classList.contains(name)) }));
      form.closest('.globo-form-app')?.classList.add('sp-submission-complete');
      // Globo updates its success text after dispatching this event.
      queueMicrotask(() => {
        if (events.signal.aborted) return;
        filledLabels.forEach(({ element, classes }) => element.classList.add(...classes));
        const messages = form.parentElement.querySelectorAll('.message.success');
        const success = messages[messages.length - 1];
        if (success) showSuccess(success);
      });
    }, { signal: events.signal });

    function initializeCountries(field) {
      if (field.querySelector('.sp-country-picker')) return;
      const fieldset = field.querySelector('fieldset');
      if (!fieldset) return;
      const picker = document.createElement('details');
      picker.className = 'sp-country-picker sp-dropdown';
      const summary = document.createElement('summary');
      const selected = document.createElement('span');
      selected.id = `${root.closest('[id]').id}-selected-countries`;
      summary.setAttribute('aria-labelledby', `${fieldset.getAttribute('aria-labelledby')} ${selected.id}`);
      summary.append(selected);
      const options = document.createElement('div');
      options.className = 'sp-country-options sp-dropdown-panel';
      const search = document.createElement('input');
      search.type = 'search';
      search.className = 'sp-country-search';
      search.placeholder = 'Search countries or regions';
      search.setAttribute('aria-label', 'Search countries or regions');
      const empty = document.createElement('p');
      empty.textContent = 'No countries or regions found.';
      empty.hidden = true;
      empty.setAttribute('role', 'status');
      fieldset.before(picker);
      options.append(search, fieldset, empty);
      picker.append(summary, options);
      const selection = document.createElement('div');
      selection.className = 'sp-country-selection';
      selection.setAttribute('role', 'group');
      selection.setAttribute('aria-label', 'Selected countries or regions');
      picker.after(selection);
      let batchSelection = false;

      const rows = Array.from(fieldset.querySelectorAll('li'));
      rows.sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), 'en'));
      const list = fieldset.querySelector('ul');
      rows.forEach(row => list.append(row));
      function removeCountries(inputs) {
        batchSelection = true;
        inputs.forEach(input => {
          input.checked = false;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        batchSelection = false;
        updateSelection();
        const next = selection.querySelector('button');
        (next || summary).focus();
      }
      function updateSelection() {
        if (batchSelection) return;
        const inputs = Array.from(fieldset.querySelectorAll('input:checked'));
        const countries = inputs.map(input => input.value);
        const text = countries.length ? countries.join(', ') : 'Select your country or region';
        if (selected.textContent !== text) selected.textContent = text;
        selection.hidden = inputs.length === 0;
        selection.replaceChildren();
        if (!inputs.length) return;
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.textContent = 'Clear all';
        clear.setAttribute('aria-label', 'Clear all countries');
        clear.addEventListener('click', () => removeCountries(inputs));
        selection.append(clear);
        inputs.forEach(input => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.setAttribute('aria-label', `Remove ${input.value}`);
          const label = document.createElement('span');
          label.textContent = input.value;
          const cross = document.createElement('span');
          cross.textContent = '×';
          cross.setAttribute('aria-hidden', 'true');
          chip.append(label, cross);
          chip.addEventListener('click', () => removeCountries([input]));
          selection.append(chip);
        });
      }
      function filterCountries() {
        const term = search.value.trim().toLocaleLowerCase('en');
        let matches = 0;
        rows.forEach(row => {
          row.hidden = !row.textContent.toLocaleLowerCase('en').includes(term);
          if (!row.hidden) matches += 1;
        });
        empty.hidden = matches > 0;
      }
      fieldset.addEventListener('change', updateSelection, { signal: events.signal });
      picker.addEventListener('toggle', () => {
        if (picker.open) root.querySelectorAll('.sp-dropdown').forEach(other => {
          if (other !== picker) other.open = false;
        });
      }, { signal: events.signal });
      search.addEventListener('input', filterCountries, { signal: events.signal });
      search.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
      }, { signal: events.signal });
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          picker.open = false;
          summary.focus();
        }
      }, { signal: events.signal });
      document.addEventListener('pointerdown', event => {
        if (!picker.contains(event.target)) picker.open = false;
      }, { signal: events.signal });
      const form = field.closest('form');
      form.addEventListener('reset', () => setTimeout(() => {
        search.value = '';
        filterCountries();
        updateSelection();
        picker.open = false;
      }, 0), { signal: events.signal });
      updateSelection();
    }

    function initializeBusiness(field) {
      if (field.querySelector('.sp-business-picker')) return;
      const select = field.querySelector('select');
      if (!select) return;
      field.classList.add('sp-business-select');
      select.dataset.spBusinessSource = 'true';
      select.hidden = true;
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
      const picker = document.createElement('details');
      picker.className = 'sp-business-picker sp-dropdown';
      const summary = document.createElement('summary');
      const selected = document.createElement('span');
      selected.id = `${select.id}-selection`;
      const label = field.querySelector('.globo-label');
      summary.setAttribute('aria-labelledby', `${label.id} ${selected.id}`);
      summary.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
      summary.setAttribute('role', 'combobox');
      summary.setAttribute('aria-haspopup', 'listbox');
      summary.setAttribute('aria-expanded', 'false');
      summary.setAttribute('aria-required', select.getAttribute('aria-required'));
      summary.append(selected);
      const options = document.createElement('div');
      options.className = 'sp-business-options sp-dropdown-panel';
      options.id = `${select.id}-options`;
      options.setAttribute('role', 'listbox');
      options.setAttribute('aria-labelledby', label.id);
      summary.setAttribute('aria-controls', options.id);
      const choices = Array.from(select.options).filter(option => option.value && !option.disabled);
      const buttons = choices.map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = option.textContent;
        const checkmark = document.createElement('span');
        checkmark.className = 'sp-business-check';
        checkmark.textContent = '✓';
        checkmark.setAttribute('aria-hidden', 'true');
        button.append(checkmark);
        button.dataset.value = option.value;
        button.setAttribute('role', 'option');
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          updateBusiness();
          picker.open = false;
          summary.focus();
        }, { signal: events.signal });
        options.append(button);
        return button;
      });
      picker.append(summary, options);
      select.after(picker);
      function updateBusiness() {
        selected.textContent = select.selectedOptions[0]?.textContent || 'Select your business type';
        buttons.forEach((button, index) => {
          const active = button.dataset.value === select.value;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active || (!select.value && index === 0) ? 0 : -1;
        });
      }
      picker.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(picker.open));
        if (picker.open) root.querySelectorAll('.sp-dropdown').forEach(other => {
          if (other !== picker) other.open = false;
        });
      }, { signal: events.signal });
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          picker.open = false;
          summary.focus();
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = buttons.indexOf(document.activeElement);
        let next = event.key === 'ArrowUp' ? buttons.length - 1 : 0;
        if (event.key === 'End') next = buttons.length - 1;
        else if (event.key !== 'Home' && current >= 0) next = (current + (event.key === 'ArrowUp' ? -1 : 1) + buttons.length) % buttons.length;
        picker.open = true;
        buttons[next]?.focus();
      }, { signal: events.signal });
      document.addEventListener('pointerdown', event => {
        if (!picker.contains(event.target)) picker.open = false;
      }, { signal: events.signal });
      select.addEventListener('change', updateBusiness, { signal: events.signal });
      const form = field.closest('form');
      form.addEventListener('reset', () => setTimeout(() => {
        updateBusiness();
        picker.open = false;
      }, 0), { signal: events.signal });
      form.addEventListener('submit', () => {
        if (!select.value) {
          picker.open = true;
          summary.focus();
        }
      }, { capture: true, signal: events.signal });
      updateBusiness();
    }

    function enhanceForm() {
      root.querySelectorAll('form.g-container').forEach(form => {
        form.querySelectorAll('button[type="submit"]').forEach(button => {
          button.classList.add('button', 'sp-retail-button');
        });
        const country = form.querySelector('.sp-country-multiselect');
        if (country) initializeCountries(country);
        const businessField = form.querySelector('[data-type="select"]');
        if (businessField) initializeBusiness(businessField);
        if (handledForms.has(form)) return;
        const details = form.querySelector('[data-type="textarea"]');
        const website = form.querySelector('.sp-company-website');
        const business = form.querySelector('[data-type="select"]');
        if (!details || !country || !website || !business) return;
        details.before(website, country, business);
        handledForms.add(form);
        const email = form.querySelector('input[data-type="email"]');
        if (email) email.type = 'email';
        const url = form.querySelector('.sp-company-website input');
        if (url) url.type = 'url';
        form.addEventListener('submit', () => {
          const picker = country.querySelector('.sp-country-picker');
          if (!country.querySelector('input:checked')) picker.open = true;
        }, { capture: true, signal: events.signal });
      });
      root.querySelectorAll('.message.success').forEach(success => {
        if (handledSuccess.has(success) || !success.getClientRects().length) return;
        if (getComputedStyle(success).visibility === 'hidden') return;
        showSuccess(success);
      });
    }

    let frame;
    const observer = new MutationObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(enhanceForm);
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    enhanceForm();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      events.abort();
      dialog.remove();
    }, { signal: events.signal });
  }

  document.querySelectorAll('[data-retail-partnership]').forEach(initializeRetailPartnership);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-retail-partnership]').forEach(initializeRetailPartnership);
  });

  } catch(e) { console.error(e); }
})();
})();
